type Paths = {
  readonly dashboard: string
  readonly adminDashboard: string
  readonly adminBusiness: string
  readonly adminAccountRegistration: string
  readonly adminBusinessRegistration: string
  readonly programs: string
  readonly members: string
  readonly staffs: string
  readonly attendancesCheckIn: string
  readonly attendancesHistory: string
  readonly billing: string
  readonly myInfo: string
  readonly businessInfo: string
  readonly login: string
  readonly paymentList: string
  readonly paymentHistory: string
  readonly termsAndServices: string
  readonly privacyPolicy: string
  readonly internalServerError: string
  readonly posSale: string
  readonly posHistory: string
  readonly posSaleResult: string
  readonly adminLockedAccount: string
  readonly emailVerification: string
  readonly emailVerificationFail: string
  readonly failedPayment: string
  readonly serviceAgreement: string
  readonly programDetail: string
  readonly adminEmailBlast: string
  readonly packages: string
  readonly reports: string
  readonly leads: string
  readonly emailTemplate: string
  readonly emailResult: string
};

export const paths: Paths = {
  dashboard: '/dashboard',
  adminDashboard: '/admin-dashboard',
  adminBusiness: '/admin-business',
  adminAccountRegistration: '/admin-account-registration',
  adminBusinessRegistration: '/admin-business-registration',
  programs: '/programs',
  members: '/members',
  staffs: '/staffs',
  attendancesCheckIn: '/attendances-checkin',
  attendancesHistory: '/attendances-history',
  billing: '/billing',
  login: '/login',
  myInfo: '/my-info',
  businessInfo: '/business-info',
  paymentList: '/payment-list',
  paymentHistory: '/payment-history',
  termsAndServices: '/terms-and-services',
  privacyPolicy: '/privacy-policy',
  internalServerError: '/internal-server-error',
  posSale: '/pos-sale',
  posHistory: '/pos-history',
  posSaleResult: '/pos-sale-result',
  adminLockedAccount: '/admin-locked-account',
  emailVerification: '/email-verification',
  emailVerificationFail: '/email-verification-fail',
  failedPayment: '/failed-payment',
  serviceAgreement: '/service-agreement',
  programDetail: '/program-detail',
  adminEmailBlast: '/admin-email-blast',
  packages: '/packages',
  reports: '/reports',
  leads: '/leads',
  emailTemplate: '/email-template',
  emailResult: '/email-result'
};



// WEBPACK FOOTER //
// ./src/app/app.routes.tsx